<template>
  <div class="text-medium-1 d-flex text-prime">
    <div
      class="circle mr-2"
      :style="{ backgroundColor: toHex(option.color) }"
      :class="{ hidden: option.color === CF_NO_COLOR, 'd-none': hideColor }"
    ></div>
    <div>{{ option.name }}</div>
  </div>
</template>

<script>
import { NO_COLOR } from '@/constants/common'
import getHexColorValueFromCode from '@/utils/initiative/getHexColorValueFromCode'

/**
 * This component gives template for CF dropdown option.
 * It shows the color and name of the option
 */
export default {
  name: 'CfDropdownOption',
  props: {
    option: Object,
    hideColor: Boolean
  },
  data() {
    return { CF_NO_COLOR: NO_COLOR }
  },
  methods: {
    toHex(color) {
      return getHexColorValueFromCode(color)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';

.circle {
  @include dimension(16px, 16px);

  border-radius: 50%;
  border: 1px solid $borderPrimary;
  margin-top: 4px;
}
</style>
